<template>
	<div class="section s66">
		<div class="center">
			<div class="common-title">
				<div class=" title">我们的赞助商</div>
				<div class=" en-title">SPONSOR</div>
			</div>
		</div>
		<div class="list">
			<div class="cen">
				<div class="left item" @click="util.toLink('https://www.amd.com/zh-cn/products/processors/server/epyc.html','','_blank')"><div class="img"></div></div>
				<div class="left item" @click="util.toLink('https://www.intel.cn/content/www/cn/zh/homepage.html','','_blank')"><div class="img"></div></div>
				<div class="left item" @click="util.toLink('https://www.microsoft.com/zh-cn/windows/business/windows-11-pro#windows11productivity','','_blank')"><div class="img"></div></div>
				<div class="left item" @click="util.toLink('https://nvidianews.nvidia.com/','','_blank')"><div class="img"></div></div>
			</div>
		</div>
		<div class="more" style="display: none">
			<div class="btn" @click="util.toLink('/contact/sponsor')"><span>查看更多</span></div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'sponsor',
	data() {
		return {}
	},
	components:{

	},
	computed:{

	},
	methods: {

	},
	mounted() {

	},
}
</script>

<style lang="scss" type="text/scss" scoped>
.common-title{overflow:hidden;font-size: 36px;line-height: 47px;color:#C8C9C7;padding: 35px 0;text-align: center;
	.title{color:#333;}
	.en-title{margin-left: 10px;font-weight: 100;text-transform: uppercase}
}
.s66{text-align: center;padding: 20px 0 50px;
	.center{width: 1200px;margin: 0 auto;
	}
	.list{text-align:center;margin-top: 30px;
		.cen{display: inline-block;
			.item{width:270px;height:80px;box-shadow: 0 0 10px 5px rgba(0,0,0,.1);border-radius: 2px;margin-right: 30px;background: #fff;cursor: pointer;
				.img{width: 200px;height:40px;margin: 20px auto 0;}
			}
			.item:nth-last-child(1){margin-right: 0;}
			.item:nth-child(1) .img{background:url("~@/assets/image/s4.png") no-repeat center center;background-size: contain;}
			.item:nth-child(2) .img{background:url("~@/assets/image/s2.png") no-repeat center center;background-size: contain;}
			.item:nth-child(3) .img{background:url("~@/assets/image/s1.png") no-repeat center center;background-size: contain;}
			.item:nth-child(4) .img{background:url("~@/assets/image/s3.png") no-repeat center center;background-size: contain;}
		}
	}
	.more{text-align: center;margin-top: 50px;
		.btn{display: inline-block;font-size: 18px;color:#fff;background:  linear-gradient(90deg,#47ced9,#357b8f); padding: 10px 20px ;cursor: pointer;transition: all .3s ease;text-align: center;border-radius: 5px;
			span{display: inline-block;padding-right: 16px; background:url("~@/assets/image/2021/9_a.png") no-repeat right center;background-size:auto 12px;}
		}
		.btn:hover{font-weight: bold; transition: all .3s ease;}
	}
}
</style>
